import { useState } from 'react'
import { CopyToClipboard } from '@wiggui/ds/CopyToClipboard'
import Button from '@wiggui/ds/Button'
import Flex from '@wiggui/ds/Flex'
import GoogleIcon from '@wiggui/ds/GoogleIcon'
import Modal from '@wiggui/ds/Modal'
import Divider from '@wiggui/ds/Divider'
import Text from '@wiggui/ds/Text'

import { useWhatsapp, useMessenger } from '../../hooks'
import { WhatsAppSvg } from '../../svg/WhatsAppSvg'
import { MessengerSvg } from '../../svg/MessengerSvg'
import { OptionsSwitch } from '../options-switch'

export interface IModalSharePublicURLOnClickProps {
  addInfoSelected: 'YES' | 'NO'
}

interface IModalSharePublicURLProps {
  url: string
  profileId?: string
  isWiggotProperty?: boolean
  onClose: () => void
  addInfoInitial?: 'YES' | 'NO'
  onClickCopyUrl?: (props: IModalSharePublicURLOnClickProps) => void
}

const ADD_INFO_OPTIONS = [
  {
    value: 'YES',
    label: (
      <Flex dir="row" items="center" justify="center" gap="gap-2" wFull>
        <GoogleIcon name="new_releases" />
        <Text className="hidden md:flex">Sí, agregar</Text>
      </Flex>
    )
  },
  {
    value: 'NO',
    label: (
      <Flex dir="row" items="center" justify="center" gap="gap-2" wFull>
        <GoogleIcon name="block" />
        <Text className="hidden md:flex">No, gracias</Text>
      </Flex>
    )
  }
]

export const ModalSharePublicURL = ({
  url,
  isWiggotProperty = false,
  profileId = '',
  addInfoInitial = 'YES',
  onClickCopyUrl,
  onClose
}: IModalSharePublicURLProps) => {
  const { redirectToWhatsapp } = useWhatsapp()
  const { redirectToMessenger } = useMessenger()
  const [addInfo, setAddInfo] = useState(addInfoInitial)

  const generateUrl = () => {
    if (isWiggotProperty) {
      if (addInfo === 'YES') {
        return `${url}${url.includes('?') ? '&' : '?'}profileId=${profileId}`
      }
      return `${url}${url.includes('?') ? '&' : '?'}withoutContact=true`
    }
    return url
  }

  const handleOnClickCopyUrl = () => {
    if (onClickCopyUrl) {
      onClickCopyUrl({
        addInfoSelected: addInfo
      })
    }
  }

  const publicURL = generateUrl()

  return (
    <Modal
      className="w-full max-w-[581px]"
      enableBgBlur
      onClose={onClose}
      isOpen={true}
    >
      <Modal.Header title="Compartir ficha" isShowCloseButton isShowDivider />
      <Modal.Body className="p-6 w-full flex gap-6 flex-col items-center justify-center">
        {isWiggotProperty && (
          <>
            <Text className="text-surface-dark text-body-l font-semibold">
              ¿Deseas agregar tus datos de asesor?
            </Text>
            <div>
              <OptionsSwitch
                activeOption={addInfo}
                onChange={(value) => setAddInfo(value as 'YES' | 'NO')}
                options={ADD_INFO_OPTIONS}
              />
            </div>
            <Text className="text-body-m text-secondary font-normal">
              {addInfo === 'YES'
                ? 'Mostraremos tus datos en la ficha'
                : 'No mostraremos tus datos'}
            </Text>
            <Divider height={1} />
          </>
        )}
        <Flex dir="col" items="center" justify="start" wFull gap="gap-6">
          <CopyToClipboard
            textToCopy={publicURL}
            className="flex flex-row w-full cursor-pointer gap-2.5 max-w-[calc(100%-55px)]"
            onClick={handleOnClickCopyUrl}
          >
            <input
              name="share-link"
              readOnly
              value={publicURL}
              className="w-full h-[52px] px-4 py-1.5 cursor-pointer hover:bg-surface-gray-10 text-secondary rounded-lg border border-surface-strokes !outline-none"
            />
            <Button variant="terciary">Copiar enlace</Button>
          </CopyToClipboard>
          <Flex
            dir="row"
            justify="evenly"
            wFull
            gap="2.5"
            className="max-w-[calc(100%-20px)] md:max-w-[calc(100%-200px)] "
          >
            <button
              className="flex flex-col items-center"
              onClick={() => {
                redirectToWhatsapp({
                  openInNewTab: true,
                  text: `Encontré esta propiedad y creo que podría interesarte. ${publicURL}`
                })
              }}
            >
              <div className="flex flex-row  justify-center items-center px-2 py-[9px] h-[48px] w-[48px] bg-notif-green-01 rounded-full">
                <WhatsAppSvg />
              </div>
              <div>WhatsApp</div>
            </button>
            <div
              className="flex flex-col items-center"
              onClick={() => {
                redirectToMessenger({ url: publicURL })
              }}
            >
              <button className="flex justify-center items-center px-2 py-[9px] h-[48px] w-[48px] bg-notif-turquoise-01 rounded-full">
                <MessengerSvg />
              </button>
              <div>Messenger</div>
            </div>
          </Flex>
        </Flex>
      </Modal.Body>
      <Modal.Footer className="w-full py-[9px] px-6" isShowDivider>
        <Button variant="secondary" fullWidth onClick={onClose}>
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
